<template>
   <div class="flex grow items-center justify-center">
      <p class="p-m text-grey">{{ text || t('common.coming-soon') }}</p>
   </div>
</template>

<script lang="ts" setup>
type Props = {
   text?: string
}

const props = withDefaults(defineProps<Props>(), {})

const { t } = useI18n()
</script>
